import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/About.css';
// Import a placeholder for your actual image
import profileImage from '../assets/images/profile-placeholder.jpg';

const About = () => {
  return (
    <>
      <Helmet>
        <title>Über mich | Catrin Kaßner – Alltagsbegleitung Jena</title>
        <meta name="description" content="Lernen Sie Catrin Kaßner kennen – examinierte Krankenschwester und selbstständige Alltagsbegleiterin in Jena. Persönliche Betreuung für Senioren im eigenen Zuhause." />
        <link rel="canonical" href="https://www.alltagsbegleitung-ckassner.de/about" />
      </Helmet>
      <div className="page-background about-background"></div>
      <div className="about">
        <h1>Über mich</h1>
        
        {/* Personal section with image */}
        <section className="personal-section">
          <div className="personal-image">
            <img src={profileImage} alt="Catrin Kaßner – Alltagsbegleiterin für Senioren in Jena" />
          </div>
          <div className="personal-content">
            <h2>Herzlich Willkommen</h2>
            <p className="personal-subtitle">Persönliche Alltagsbegleitung mit Herz</p>
            <p>
            Mein Name ist Catrin Kaßner, und ich möchte Sie im Alltag unterstützen.
            Nach vielen Jahren als Krankenschwester mit Zusatzqualifikation zur Operationsschwester habe ich mich entschieden, 
            einen neuen Weg einzuschlagen – als selbstständige Alltagsbegleiterin in Jena.
            </p>
            <p>
            Mein Anliegen ist es, Senioren in Jena und Umgebung im eigenen Zuhause zu unterstützen und ihnen ein selbstbestimmtes, 
            angenehmes Leben zu ermöglichen. Ob kleine Hilfen im Haushalt, gemeinsame Spaziergänge oder einfach Zeit für Gespräche – ich bin für Sie da. 
            Dabei spielt es keine Rolle, ob ein Pflegegrad vorliegt oder nicht.
            </p>
            <p>
            Lernen wir uns doch unverbindlich kennen! In einem kostenlosen Erstgespräch besprechen wir Ihre Wünsche und den passenden Rahmen der Unterstützung. 
            Ich freue mich darauf, Sie kennenzulernen!
            </p>
          </div>
        </section>
        
        {/* Vision and goal section */}
        <section className="vision-section">
          <h2>Was ich erreichen möchte</h2>
          <div className="vision-content">
            <div className="vision-item">
              <i className="fas fa-home"></i>
              <h3>Selbstständigkeit fördern</h3>
              <p>Mein Ziel ist es, Senioren dabei zu helfen, so lange wie möglich selbstbestimmt in ihrem gewohnten Umfeld zu leben.</p>
            </div>
            
            <div className="vision-item">
              <i className="fas fa-heart"></i>
              <h3>Lebensqualität verbessern</h3>
              <p>Durch persönliche Betreuung und Zuwendung möchte ich die Lebensfreude und das Wohlbefinden im Alltag steigern.</p>
            </div>
            
            <div className="vision-item">
              <i className="fas fa-hands-helping"></i>
              <h3>Entlastung bieten</h3>
              <p>Angehörige entlasten und ihnen die Gewissheit geben, dass ihre Liebsten in guten Händen sind.</p>
            </div>
          </div>
        </section>
        
        <div className="about-content">
          <section className="mission">
            <h2>Meine Mission</h2>
            <p>Als lebensfrohe und aufgeweckte Person habe ich es mir zur Aufgabe gemacht, fürsorgliche und persönliche Betreuung anzubieten, die die Lebensqualität älterer Menschen verbessert.</p>
          </section>
          <section className="values">
            <h2>Meine Werte</h2>
            <ul>
              <li>Persönliche und herzliche Betreuung</li>
              <li>Respektvoller Umgang und Wahrung der Würde</li>
              <li>Zuverlässigkeit und Vertrauenswürdigkeit</li>
              <li>Individuelle Betreuung nach Ihren Bedürfnissen</li>
            </ul>
          </section>
        </div>
      </div>
    </>
  );
};

export default About;
